import * as React from 'react';
import {StyleProp, StyleSheet, ViewStyle} from 'react-native';
import {useLinkTo} from '@react-navigation/native';

import BottomPrimaryButton from '../../../shared/buttons/BottomPrimaryButton';

interface Props {
  style?: StyleProp<ViewStyle>;
}

const SearchOffersButton: React.FC<Props> = props => {
  const {style} = props;
  const linkTo = useLinkTo();
  const onPress = React.useCallback(() => {
    linkTo('/writers_gate/manuscripts');
  }, []);
  return (
    <BottomPrimaryButton
      style={style}
      bottomButtonStyle={styles.bottomButton}
      onPress={onPress}>
      提出管理
    </BottomPrimaryButton>
  );
};

export default React.memo(SearchOffersButton);

const styles = StyleSheet.create({
  bottomButton: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  } as ViewStyle,
});
